import {has_ssr} from "@core/helpers/render-type";
import {get_current_locate_server} from "@core/helpers/server/locate";
import {get_cookie} from "@core/helpers/cookie";


export const get_current_locate = async () => {
	if (has_ssr()) {
		return await get_current_locate_server();
	}
	return await get_cookie("locale")
}

export const get_current_locate_un_force = async () => {
	if (has_ssr()) {
		return await get_current_locate_server(false);
	}
	return await get_cookie("locale")
}

export const get_current_locate_from_cookie = async () => {
	return await get_cookie("locale")
}